// extracted by mini-css-extract-plugin
module.exports = {"character":"Character_character__1nQZP","downloadSVG":"Character_downloadSVG__2sDrf"};